/**
 * Geo-based store routing modal for Bread & Butter Pickleball.
 *
 * Two stores:
 *   Main  → https://www.bnbpickleball.com  (US / global)
 *   Asia  → https://asia.bnbpickleball.com (Asia-Pacific)
 *
 * Detection signal: window.SelkirkStore.countryName
 * Set by an inline <script> in layout/theme.liquid using Shopify Liquid:
 *   {{ localization.country.name | json }}
 *
 * IMPORTANT: Verify ASIA_COUNTRY_NAMES against the exact strings that appear
 * in window.SelkirkStore.countryName when a visitor from an Asia-Pacific
 * country loads the main store (check browser console on a VPN/proxy).
 * The values come from Shopify Admin → Settings → Markets.
 */

var Localization = (function () {
  var STORE_NAME       = 'Bread & Butter Pickleball';
  var MAIN_STORE_URL   = 'https://www.bnbpickleball.com';
  var ASIA_STORE_URL   = 'https://asia.bnbpickleball.com';

  /**
   * Country names for the Asia-Pacific markets configured in Shopify Admin.
   * Must match window.SelkirkStore.countryName exactly (case-insensitive).
   * Verify by loading the Asia store on a VPN in each country and checking
   * the console log for window.SelkirkStore.countryName.
   */
  var ASIA_COUNTRY_NAMES = [
    'brunei',
    'china',
    'hong kong sar',
    'indonesia',
    'japan',
    'malaysia',
    'philippines',
    'singapore',
    'south korea',
    'taiwan',
    'thailand',
    'vietnam'
  ];

  // ─── helpers ─────────────────────────────────────────────────────────────

  function isModalExcludedPath(pathname) {
    return /\/blogs(\/|$)/.test(pathname) || /\/pages(\/|$)/.test(pathname);
  }

  function hasActiveDismissal() {
    try {
      return sessionStorage.getItem('regionChangePopupDismissed') === 'true';
    } catch (e) {
      return false;
    }
  }

  function setDismissal() {
    try {
      sessionStorage.setItem('regionChangePopupDismissed', 'true');
    } catch (e) {}
  }

  // ─── modal open / close ───────────────────────────────────────────────────

  function openModal() {
    var backdrop = document.getElementById('region-change-modal-backdrop');
    var modal    = document.getElementById('region-change-modal');
    if (backdrop) backdrop.classList.add('is-open');
    if (modal) {
      modal.classList.add('is-open');
      modal.focus();
    }
  }

  function closeModal() {
    var backdrop = document.getElementById('region-change-modal-backdrop');
    var modal    = document.getElementById('region-change-modal');
    if (backdrop) backdrop.classList.remove('is-open');
    if (modal)    modal.classList.remove('is-open');
    setDismissal();
  }

  // ─── populate & show modal ───────────────────────────────────────────────

  function showStorePrompt(storeData) {
    var isAsiaStore  = storeData.shopUrl.indexOf('asia') !== -1;
    var countryName  = storeData.countryName || 'your region';

    var titleEl    = document.getElementById('region-change-modal-title');
    var bodyEl     = document.getElementById('region-change-modal-body');
    var stayEl     = document.getElementById('region-change-modal-stay');
    var continueEl = document.getElementById('region-change-modal-continue');

    if (!titleEl || !bodyEl || !stayEl || !continueEl) return;

    if (isAsiaStore) {
      // Visitor is on the Asia store but Shopify resolved them outside Asia-Pacific
      titleEl.textContent = 'WELCOME TO ' + STORE_NAME + ' ASIA';
      bodyEl.textContent  =
        'You\u2019re browsing from ' + countryName + '. ' +
        'This store only ships within Asia-Pacific. ' +
        'Please visit ' + MAIN_STORE_URL + ' to place your order.';
      stayEl.textContent     = 'Stay anyway';
      continueEl.textContent = 'Go to ' + STORE_NAME;
      continueEl.href        = MAIN_STORE_URL;
    } else {
      // Visitor is on the main store but Shopify resolved them to Asia-Pacific
      titleEl.textContent = 'WELCOME TO ' + STORE_NAME;
      bodyEl.textContent  =
        'You\u2019re browsing from ' + countryName + '. ' +
        'Switch to ' + STORE_NAME + ' Asia for faster delivery and lower shipping costs.';
      stayEl.textContent     = 'Stay on ' + MAIN_STORE_URL;
      continueEl.textContent = 'Go to ' + STORE_NAME + ' Asia';
      continueEl.href        = ASIA_STORE_URL;
    }

    openModal();
  }

  // ─── routing check ───────────────────────────────────────────────────────

  function checkStoreRouting() {
    var storeData = window.SelkirkStore;
    if (!storeData) return;

    if (isModalExcludedPath(window.location.pathname)) return;
    if (hasActiveDismissal()) return;

    var isAsiaStore  = storeData.shopUrl.indexOf('asia') !== -1;
    var countryName  = (storeData.countryName || '').toLowerCase();
    console.log('countryName:', countryName, 'shopUrl:', storeData.shopUrl);
    var isAsiaMarket = ASIA_COUNTRY_NAMES.indexOf(countryName) !== -1;

    if (isAsiaStore && !isAsiaMarket) {
      // On Asia store, but visitor's geo is NOT one of the Asia markets → prompt to switch to main
      showStorePrompt(storeData);
    } else if (!isAsiaStore && isAsiaMarket) {
      // On main store, but visitor's geo IS one of the Asia markets → prompt to switch to Asia store
      showStorePrompt(storeData);
    }
  }

  // ─── event binding ───────────────────────────────────────────────────────

  function bindEvents() {
    var backdrop   = document.getElementById('region-change-modal-backdrop');
    var stayBtn    = document.getElementById('region-change-modal-stay');
    var continueEl = document.getElementById('region-change-modal-continue');

    if (backdrop) {
      backdrop.addEventListener('click', closeModal);
    }

    if (stayBtn) {
      stayBtn.addEventListener('click', closeModal);
    }

    // <a> handles the redirect; we only need to record the dismissal
    if (continueEl) {
      continueEl.addEventListener('click', setDismissal);
    }
  }

  // ─── public API ──────────────────────────────────────────────────────────

  function init() {
    bindEvents();
    checkStoreRouting();
  }

  return {
    isModalExcludedPath: isModalExcludedPath,
    hasActiveDismissal:  hasActiveDismissal,
    setDismissal:        setDismissal,
    checkStoreRouting:   checkStoreRouting,
    showStorePrompt:     showStorePrompt,
    init:                init
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  Localization.init();
});
